module.exports = __webpack_public_path__ + "img/g4.22a057f7.png";